
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import FullScreenError from '~/components/UIComponents/FullScreenError.vue';
import { ThemeName, TSiteConfigState } from '~/store/types';
import { SanityDocumentSchema } from '~/types/sanity-documents';
import ProjectsPage from '~/components/Films/ProjectsPage.vue';

@Component({
  meta: {
    theme: ThemeName.DARK,
  },
  components: {
    FullScreenError,
    ProjectsPage,
  },
})
export default class Collection extends Vue {
  @Getter('siteConfig')
  readonly siteConfigState!: TSiteConfigState;

  schemas = SanityDocumentSchema;

  get pageSchema() {
    return this.$sanityLookup.getSchemaFromRouteParams(this.$route.params);
  }
}
